import React, {useState, useContext} from 'react'
import { languages } from '../../../Helpers/languages'
import axios from 'axios'
import { GlobalContext } from '../../../Context/GlobalContext'
import { BASE_PATH } from '../../../constants/awsBaseUrl'


const SelectOption = ({translations, setPopup, file}) => {
  const {ownerOfVODId} = useContext(GlobalContext)
  const [lang, setLang] = useState(null)
  const downloadCaptionFile = (e) => {
    e.preventDefault()
    axios({
      url:lang? `${BASE_PATH}/captions-translated/${file._id}/${file._id}-${lang}.vtt`:`${BASE_PATH}/captions/${file._id}.vtt`, //your url
      method: "GET",
      responseType: "blob", // important
    })
    .then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      //or any other extension
      link.setAttribute("download", `${file.metadata.filename}.vtt`); 
      document.body.appendChild(link);
      link.click();
    });
  }

    return (<>
    <div className='login-wrapper'>
      <div className="login-body">
        <div className="login-x" onClick={() => setPopup(false)}>
            <i className="fas fa-times"></i>
          </div>
        <div style={{display:'flex', flexDirection:'column', justifyContent:'space-around'}}>
      <h3>Download Captions</h3>
      <br/>
      <p>Select a language to download captions</p>
      
      <select value={null} onChange={e=>setLang(e.target.value)}>
        <option value={null}>English</option>
        {translations.map((language, idx)=> <option key={idx} value={language}>{languages.filter(lan=>lan.key==language)[0].language}</option>)}
      </select>
      
      <br/>
      <br/>
        <span style={{display:'flex', justifyContent:'space-between'}}>
            <button className='btn btn-outline-secondary' onClick={(e)=>{e.preventDefault(); setPopup(false)}}>Cancel</button>
         <button className='btn btn-outline-primary' onClick={downloadCaptionFile}>Download</button>   
        </span>
      
      </div>
      </div>
    </div>
    </>)
}

export default SelectOption